module.exports = {
	"id": "BZ",
	"name": "Belize",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.020272,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.010136,
			"19": null,
			"20": 0.010136,
			"21": 0.010136,
			"22": 0.030408,
			"23": 0.015204,
			"24": null,
			"25": 0.010136,
			"26": 0.005068,
			"27": 0.035476,
			"28": null,
			"29": 0.015204,
			"30": null,
			"31": 0.020272,
			"32": 0.015204,
			"33": 0.045612,
			"34": 0.02534,
			"35": 0.060816,
			"36": 0.030408,
			"37": 0.005068,
			"38": 0.015204,
			"39": 0.086156,
			"40": 0.070952,
			"41": 0.010136,
			"42": 0.045612,
			"43": 0.141904,
			"44": 0.02534,
			"45": 0.040544,
			"46": 0.030408,
			"47": 0.030408,
			"48": 0.035476,
			"49": 1.5204,
			"50": 0.141904,
			"51": 0.623364,
			"52": 0.400372,
			"53": 19.7652,
			"54": 5.1947,
			"55": 0.106428,
			"56": 0.035476,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.005068,
			"4": null,
			"5": 0.005068,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.010136,
			"13": null,
			"14": 0.010136,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.010136,
			"21": null,
			"22": 0.005068,
			"23": 0.010136,
			"24": null,
			"25": null,
			"26": 0.010136,
			"27": null,
			"28": 0.035476,
			"29": null,
			"30": 0.005068,
			"31": 0.015204,
			"32": 0.010136,
			"33": 0.015204,
			"34": 0.005068,
			"35": 0.010136,
			"36": 0.015204,
			"37": 0.015204,
			"38": 0.065884,
			"39": 0.035476,
			"40": 0.1267,
			"41": 0.05068,
			"42": 0.055748,
			"43": 0.131768,
			"44": 0.030408,
			"45": 0.111496,
			"46": 0.1267,
			"47": 0.58282,
			"48": 0.364896,
			"49": 7.176288,
			"50": 0.299012,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.010136
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005068,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.05068,
			"38": 0.05068,
			"39": 0.005068,
			"40": 0.141904,
			"41": 0.030408,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.010136
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.015204,
			"6": null,
			"7": 0.02534,
			"8": 0.1267,
			"9": 0.192584,
			"10": 1.378496,
			"3.1": null,
			"3.2": null,
			"5.1": 0.091224,
			"6.1": 0.030408,
			"7.1": null,
			"9.1": 0.648704
		},
		"ios_saf": {
			"8": 0,
			"10": 4.40070013739,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.11859377654,
			"8.1-8.4": 0.219096976998,
			"9.0-9.2": 0.104523328476,
			"9.3": 1.5946507806
		},
		"android": {
			"3": 0,
			"4": 0.122152297158,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0152690371447,
			"4.1": 0.440620786176,
			"4.2-4.3": 1.10155196544,
			"4.4": 2.52593500194,
			"4.4.3-4.4.4": 2.54774791214
		},
		"ie": {
			"6": null,
			"7": 0.0101513111782,
			"8": 0.192874912387,
			"9": 0.137042700906,
			"10": 0.157345323263,
			"11": 2.86266975227,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0479671747803,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00133242152168
		},
		"edge": {
			"12": 0.339556,
			"13": 0.978124,
			"14": 0.942648
		},
		"ie_mob": {
			"10": 0.320992394366,
			"11": 1.30689760563
		},
		"bb": {
			"7": 0.02096525,
			"10": null
		},
		"samsung": {
			"0": 3.975998
		},
		"and_uc": {
			"0": 1.455235
		},
		"op_mini": {
			"0": 0.646253403698
		},
		"and_chr": {
			"0": 31.740702
		},
		"and_ff": {
			"0": 0.014799
		}
	},
	"total": 99.19047625
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BZ.json
 ** module id = 488
 ** module chunks = 0
 **/